<script>
export default {
    props: ['data', 'type'],
    name: "studyList",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="study_list flex flex_wrap" :class="type">
        <div class="item" v-for="(item, index) in data" :key="index">
            <div class="cover">
                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                <div class="type text_shadow">{{ item.tag }}</div>
            </div>
            <div class="desc">{{ item.desc }}</div>
            <div class="name">{{ item.name }}</div>
            <div class="time flex align_center">
                <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                <p>{{ item.start_time }} - {{ item.end_time }}</p>
            </div>
            <div class="flex justify_between align_center">
                <div class="price flex align_center">
                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                    <p v-if="item.price == '0.00'">免费</p>
                    <p v-else>RMB {{ item.price }}</p>
                </div>
                <router-link class="btn layout_flex_center" :to="`/study/detail?id=${item.id}`">更多信息</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.study_list{
    gap: .5rem;
    @media only screen and (max-width: 750px) {
        gap: .3rem;
    }
    &.type2{
        .item{
            width: 3.66rem;
            @media only screen and (max-width: 750px) {
                width: 100%;
            }
        }
    }
    .item{
        width: 3.4rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .cover{
            position: relative;
            margin-bottom: .2rem;
            @media only screen and (max-width: 750px) {
                margin-bottom: .3rem;
            }
            .bg{
                height: 0;
                padding-bottom: 79.41%;
                @media only screen and (max-width: 750px) {
                    padding-bottom: 76.81%;
                }
                // 
                // border: 1px solid #000;
            }
            .type{
                color: #fff;
                position: absolute;
                top: .2rem;
                left: 0;
                // background: #fff;
                font-size: .14rem;
                height: .25rem;
                // border: 1px solid #000;
                border-left: 0;
                padding: 0 .2rem;
                @media only screen and (max-width: 750px) {
                    font-size: .26rem;
                    padding: 0;
                    left: .2rem;
                }
            }
        }
        .desc{
            font-size: .2rem;
            margin-bottom: .15rem;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
                margin-bottom: .2rem;
            }
        }
        .name{
            font-size: .22rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
                margin-bottom: .2rem;
            }
        }
        .time,
        .price{
            font-size: .18rem;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .22rem;
            }
        }
        .time{
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                margin-bottom: .2rem;
            }
        }
        .icon{
            margin-right: .1rem;
            &.calendar{
                width: .21rem;
            }
            &.price{
                width: .24rem;
            }
            @media only screen and (max-width: 750px) {
                &.calendar{
                    width: .29rem;
                }
                &.price{
                    width: .32rem;
                }
            }
        }
        .btn{
            font-size: .16rem;
            color: #666;
            border: 1px solid #666;
            border-radius: .1rem;
            height: .25rem;
            padding: 0 .05rem;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                border-radius: 0;
                font-size: .2rem;
                height: .4rem;
                padding: 0 .15rem;
            }
        }
    }
}
</style>